import { mutationOptions } from '@tanstack/react-query';
import { registerPartnersBaseURL } from '#constants/hosts';
import { client } from '#queries/utils';

function createSubmitMutation(path: string) {
  return mutationOptions({
    mutationFn: (registrationId: string): Promise<void> =>
      client(`${registerPartnersBaseURL}/client_api/registrations/${registrationId}/${path}`, {
        method: 'POST',
      }),
  });
}

function submit() {
  return createSubmitMutation('submit');
}

function submitAsync() {
  return createSubmitMutation('submit_async');
}

export const registerPartnersMutations = {
  submit,
  submitAsync,
};
